<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="产品系列名称：" prop="productModelName">
          <el-input
            v-model.trim="queryForm.productModelName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品系列：" prop="productModelId">
          <el-select
            v-model="queryForm.productModelId"
            placeholder="--选择产品系列--"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="handleModelData"
          >
            <el-option
              v-for="item in proModelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="膜卷号：" prop="rollNumber">
          <el-input
            v-model.trim="queryForm.rollNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店：" prop="storeId">
          <el-select
            v-model="queryForm.storeId"
            placeholder="--选择门店--"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="getStoreList"
          >
            <el-option
              v-for="item in storeDataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            v-model="queryForm.partnerId"
            placeholder="--选择经销商--"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="getPartnerList"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select
            v-model="queryForm.status"
            clearable
            placeholder="--选择状态--"
          >
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button type="primary" @click="getTableData">导出表格</el-button>
        </el-form-item>
      </el-form>

      <!-- 批量上传 -->

      <el-row type="flex" class="row-bg" justify="first">
        <el-form style="width: 200px" class="demo-form-inline forms">
          <el-form-item label="批量上传：">
            <el-upload
              ref="upload"
              class="upload-demo"
              action
              :on-change="handleChange"
              :on-remove="handleRemove"
              :limit="limitUpload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :auto-upload="false"
            >
              <div class="el-upload__text" style="color: #fff">选择文件</div>
              <div slot="tip" class="el-upload__tip">
                只 能 上 传 xlsx / xls 文 件
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-form
          style="
            width: 240px;
            heigth: 36px;
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
          "
        >
          <el-button
            size="medium"
            type="primary"
            @click="up"
            :loading="isLoading"
            >上传</el-button
          >
          <div class="muban">
            <a
              style="color: #fff"
              download="膜卷号模板.xlsx"
              :href="
                'https://ppf-wx.oss-cn-shanghai.aliyuncs.com/%E8%B4%A8%E4%BF%9D%E4%BA%A7%E5%93%81%E6%A8%A1%E6%9D%BF.xlsx?' +
                  new Date().getTime()
              "
              >模板下载</a
            >
          </div>
        </el-form>
      </el-row>
    </div>
    <div class="table">
      <div class="content">
        <!-- :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" -->
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号" key="id"></el-table-column>
          <el-table-column
            prop="rollNumber"
            label="膜卷号"
            key="rollNumber"
          ></el-table-column>
          <el-table-column
            prop="productModelName"
            label="系列名称"
            key="productModelName"
          ></el-table-column>
          <el-table-column
            prop="productTypeName"
            label="型号名称"
            key="productTypeName"
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            label="经销商名称"
            key="partnerName"
          ></el-table-column>
          <el-table-column
            prop="storeName"
            label="门店名称"
            key="storeName"
          ></el-table-column>
          <el-table-column
            prop="warrantyCount"
            label="质保次数"
            key="warrantyCount"
          ></el-table-column>
          <el-table-column
            prop="useWarrantyCount"
            label="已消耗次数"
            key="useWarrantyCount"
          ></el-table-column>
          <el-table-column prop="status" key="status" label="状态" width="120">
            <template slot-scope="scope">
              {{
                scope.row.status == 1
                  ? "未耗尽"
                  : scope.row.status == 2
                  ? "已耗尽"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="180" key="todo" label="操作">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改质保产品"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="膜卷号：" prop="rollNumber">
          <el-input
            v-model.trim="editForm.rollNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品系列：" prop="productModelId">
            <el-select
              @change="handleModelData"
              v-model="editForm.productModelId"
              placeholder="--选择产品系列--"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleModelData"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号：" prop="productTypeId">
            <el-select
              v-model="editForm.productTypeId"
              placeholder="--选择产品型号--"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleModel"
            >
              <el-option
                v-for="item in proModelTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            v-model="editForm.partnerId"
            placeholder="--选择经销商--"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="getPartnerList"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="质保次数：" prop="warrantyCount">
          <el-input
            v-model.trim="editForm.warrantyCount"
            auto-complete="off"
            type="number"
            :max="9999999"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加质保产品"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="膜卷号：" prop="rollNumber">
          <el-input
            v-model.trim="newForm.rollNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品系列：" prop="productModelId">
            <el-select
              @change="handleModelData"
              v-model="newForm.productModelId"
              placeholder="--选择产品系列--"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleModelData"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号：" prop="productTypeId">
            <el-select
              v-model="newForm.productTypeId"
              placeholder="--选择产品型号--"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="handleModel"
            >
              <el-option
                v-for="item in proModelTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            v-model="newForm.partnerId"
            placeholder="--选择经销商--"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="getPartnerList"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="质保次数：" prop="warrantyCount">
          <el-input
            v-model.trim="newForm.warrantyCount"
            auto-complete="off"
            type="number"
            :max="9999999"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMJGL, getCPJM, getYYS, getMD, getCP } from "../axios/api";
import { writeFile } from "../utils/xlsx";
import moment from "dayjs";
export default {
  name: "Cpyx",
  data() {
    return {
      statusList: [
        { id: 1, name: "未耗尽" },
        { id: 2, name: "已耗尽" },
      ],
      proModelList: [], // 产品系列
      proModelTypeList: [], // 产品型号
      partnerList: [], // 经销商
      storeDataList: [], // 门店
      BatchNumber: "",
      ProductName: "",
      Agency: "",
      AgencyList: {},
      fileTemp: null,
      limitUpload: 1, // 限制上传数量
      isLoading: false, // 上传
      editFormVisible: false, //编辑弹框
      newData: false, //添加弹框
      editForm: {
        rollNumber: "",
        warrantyCount: null,
        productModelId: null,
        partnerId: null
      }, //编辑弹框数据
      newForm: {
        rollNumber: "",
        warrantyCount: null,
        productModelId: null,
        partnerId: null
      }, //添加弹框数据
      queryForm: {
        rollNumber: "",
        productModelName: null,
        storeId: null,
        partnerId: null
      },
      params: {},
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      dialogFormVisible: false,
      form: {},
      eTableData: [],
      eTabelLoading: false,
      rules: {
        rollNumber: [
          { required: true, message: "请输入膜卷号", trigger: "blur" }
        ],
        warrantyCount: [
          { required: true, message: "请输入质保次数", trigger: "blur" }
        ],
        productModelId: [
          { required: true, message: "请输入系列", trigger: "change" }
        ],
        productTypeId: [
          { required: true, message: "请输入型号", trigger: "change" }
        ],
        partnerId: [
          { required: true, message: "请输入经销商", trigger: "change" }
        ]
      }
    };
  },
  watch:{
    params(newValue){
      this.init(newValue)
    },
    eTableData(newVal){
      if (newVal.length === this.total) {
        this.exprotData()
      }
    }
  },
  methods: {
    exprotData() {
      // 获取导出数据
      if (this.eTableData.length === this.total) {
        this.eTabelLoading = false;
        this.$message({
          type: "success",
          message: "导出成功！"
        });
        //
        const SheetHeader = [
          { key: "id", label: "编号" },
          { key: "rollNumber", label: "膜卷号" },
          { key: "productModelName", label: "系列名称" },
          { key: "productTypeName", label: "型号名称" },
          { key: "storeName", label: "门店" },
          { key: "partnerName", label: "经销商" },
          { key: "warrantyCount", label: "质保次数" },
          { key: "useWarrantyCount", label: "已消耗次数" },
          {
            key: "status",
            label: "状态",
            render: value => ["", "未耗尽", "已耗尽"][value]
          },
          { key: "createdAt", label: "创建时间" }
        ];
        writeFile(
          this.eTableData,
          SheetHeader,
          `质保产品管理数据${moment(new Date()).format("YYYY-MM-DD")}`
        );
      }
    },
    //
    getTableData() {
      var that = this;
      that.eTabelLoading = true;
      this.$message({
        type: "warning",
        message: "正在导出请稍后！"
      });
      //获取列表

      let data = {
        productModelName: that.queryForm.productModelName
          ? that.queryForm.productModelName
          : undefined,
        productModelId: that.queryForm.productModelId
          ? that.queryForm.productModelId
          : undefined,
        rollNumber: that.queryForm.rollNumber
          ? that.queryForm.rollNumber
          : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        storeId: that.queryForm.storeId ? that.queryForm.storeId : undefined,
        status: that.queryForm.status ? that.queryForm.status : undefined,
        pageNumber: 1,
        pageSize: 1000
      };
      // console.log(data)
      getMJGL.getTable(data).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list } = res.data;

          console.log(list);

          list.map(lis => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });

          that.eTableData = list;
        }
      });
    },
    // 根据系列获取型号
    handleModel: function(query) {
      let that = this;
      if (that.newForm.productModelId || that.editForm.productModelId) {
        getCP
          .getTable({
            productModelId:
              that.newForm.productModelId || that.editForm.productModelId,
            pageSize: 1000,
            pageNumber: 1,
            name: query || undefined
          })
          .then(function(res) {
            if (res.code !== 0) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
            } else {
              const { list } = res.data;

              that.proModelTypeList = list;
            }
          });
      }
    },
    // 获取系列数据和经销商数据，门店数据
    handleModelData: function(query) {
      let that = this;
      let proModelData = {
        pageSize: 1000,
        pageNumber: 1,
        name: query || undefined
      };
      // console.log(data)
      //获取系列列表
      getCPJM.getWFTable(proModelData).then(function(res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          const { list } = res.data;

          that.proModelList = list;
        }
      });

      // 获取型号
      that.handleModel();
    },
    // 经销商
    getPartnerList(query) {
      let that = this;
      // 获取经销商

      let partnerData = {
        pageNumber: 1,
        pageSize: 1000,
        name: query || undefined
      };
      // console.log(data)
      getYYS.getTable(partnerData).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list } = res.data;
          that.partnerList = list;
        }
      });
    },
    // 获取门店
    getStoreList(query) {
      let that = this;
      getMD
        .getTable({ pageSize: 1000, pageNumber: 1, name: query || undefined })
        .then(function(res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定"
            });
          } else {
            const { list } = res.data;
            that.storeDataList = list;
          }
        })
        .catch(function(res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        });
    },
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },

    up: function() {
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          this.isLoading = true;
          this.$message({
            type: "warning",
            message: "正在上传"
          });
          this.importfxx(this.fileTemp);
          this.fileTemp = null;
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！"
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！"
        });
      }
    },

    importfxx(obj) {
      let that = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          // console.log(outdata);

          outdata.map(function(item) {
            item.rollNumber = item.膜卷号 ? item.膜卷号.toString().trim() : "";
            item.warrantyCount = item.质保次数 ? item.质保次数 : "";
            item.productTypeId = item.产品型号 ? item.产品型号 : "";
            item.partnerId = item.经销商 ? item.经销商 : "";

            delete item.膜卷号;
            delete item.质保次数;
            delete item.产品型号;
            delete item.经销商;
          });
          console.log(outdata);
          // 调用上传接口
          that.batchNewUpdate(outdata);
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },

    batchNewUpdate: async function(batchData) {
      var that = this;
      let data = [];

      for (var i = 0; i < batchData.length; i++) {
        await getMJGL
          .addTable(JSON.stringify(batchData[i]))
          .then(function(res) {
            if (res.code !== 0) {
              that.$message.error("上传失败！" + res.message || res);
              data.push(batchData[i].rollNumber);
            }
          })
          .catch(function(error) {
            that.$message.error("上传失败！" + error);

            data.push(batchData[i].rollNumber);
          });
      }

      if (data && data.length) {
        that.$alert(data.toString() + "上传失败！", "提示", {
          confirmButtonText: "确定"
        });
        that.isLoading = false;
      } else {
        that.$message.success("上传成功！");
        that.isLoading = false;
        that.init();
      }
    },

    //搜索
    search: function() {
      var that = this;
      that.params = { ...this.queryForm };
    },
    reset: function() {
      this.queryForm = {};
      this.currentPage = 1;
      this.params = {};
    },
    add: function() {
      this.newData = true; //显示弹框

      this.handleModelData();
      this.getPartnerList();
    },
    //点击关闭dialog
    newClose(done) {
      this.newData = false;
      this.$refs["newForm"].resetFields();

      this.handleModelData();
      this.getPartnerList();
    },
    //点击取消
    newCancel(formName) {
      this.newData = false;
      this.$refs["newForm"].resetFields();

      this.handleModelData();
      this.getPartnerList();
    },
    edit(index, row) {
      this.dialogFormVisible = true;
      this.form = Object.assign(row);
      console.log(this.form);
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate(valid => {
        if (valid) {
          //更新的时候就把弹出来的表单中的数据写到要修改的表格中
          var data = {
            rollNumber: this.newForm.rollNumber.trim(),
            warrantyCount: Number(this.newForm.warrantyCount),
            productTypeId: this.newForm.productTypeId,
            partnerId: this.newForm.partnerId
          };
          //这里再向后台发个post请求重新渲染表格数据
          getMJGL
            .addTable(JSON.stringify(data))
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                console.log(res.list);
                that.$message({
                  type: "success",
                  message: "添加成功!"
                });
                (that.newForm = {}), that.$refs["newForm"].resetFields();
                that.newData = false;
                that.currentPage = 1;
                that.init();
              }
            })
            .catch(function(res) {
              //清空
              (that.newForm = {}), that.$refs["newForm"].resetFields();
              that.newData = false;
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    download: function() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../vendor/Export2Excel.js");
        const tHeader = [
          "经销商名称",
          "膜卷号",
          "产品名称",
          "产品类型(1:漆面膜,2:窗膜前档,3:窗膜前档)",
          "质保年限(数字格式，99代表永久)",
          "料号",
          "规格"
        ];
        const filterVal = [
          "Agency",
          "BatchNumber",
          "ProductName",
          "Type",
          "GPYear",
          "MaterialCode",
          "Spec"
        ];
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "质保产品");
      });
    },
    formatDate(numb, format) {
      if (typeof numb == "undefined") {
        return "";
      }
      const time = new Date((numb - 1) * 24 * 3600000 + 1);
      time.setYear(time.getFullYear() - 70);
      const year = time.getFullYear() + "";
      const month = time.getMonth() + 1 + "";
      const date = time.getDate() - 1 + "";
      if (format && format.length === 1) {
        return year + format + month + format + date;
      }
      return (
        year +
        (month < 10 ? "0" + month : month) +
        (date < 10 ? "0" + date : date)
      );
    },
    current_change: function(currentPage) {
      // console.log(currentPage)
      this.params = { ...this.params, pageNumber: currentPage };
    },
    //点击编辑
    bj: function(index, row) {
      var that = this;
      this.editFormVisible = true; //显示弹框
      //将每一行的数据赋值给Dialog弹框（这里是重点）
      this.editForm = Object.assign(row); // editForm是Dialog弹框的data

      this.handleModelData();
      this.getPartnerList();
    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;

      //
      this.handleModelData();
      this.getPartnerList();
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      //
      this.handleModelData();
      this.getPartnerList();
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中
      var data = {
        rollNumber: that.editForm.rollNumber.trim(),
        warrantyCount: Number(that.editForm.warrantyCount),
        productTypeId: that.editForm.productTypeId,
        partnerId: that.editForm.partnerId
      };
      // console.log(data)
      // return
      getMJGL
        .editTable(data, that.editForm.id)
        .then(function(res) {
          if (res.code !== 0) {
            that.editFormVisible = false;
            // console.log(res)
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定"
            });
          } else {
            // console.log(res.data)
            that.$message({
              type: "success",
              message: "更新成功!"
            });
            that.editFormVisible = false;
            that.init({ ...that.params });
          }
        })
        .catch(function(res) {
          that.editFormVisible = false;
          // console.log(res)
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        });
    },
    //点击删除
    sc: function(index, row) {
      var that = this;
      // console.log(row)
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          getMJGL
            .delTable({
              id: row.id
            })
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
                that.currentPage = 1;
              } else {
                // console.log(res.data)
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            })
            .catch(function(res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
              that.currentPage = 1;
              that.init();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    init: function(values = {}) {
      var that = this;
      that.loading = true;
      //获取产品类型列表

      let data = {
        productModelName: values.productModelName
          ? values.productModelName
          : undefined,
        productModelId: values.productModelId
          ? values.productModelId
          : undefined,
        rollNumber: values.rollNumber ? values.rollNumber : undefined,
        partnerId: values.partnerId ? values.partnerId : undefined,
        storeId: values.storeId ? values.storeId : undefined,
        status: values.status ? values.status : undefined,
        pageSize: values.pagesize || 10,
        pageNumber: values.pageNumber || 1
      };
      //获取产品原型
      getMJGL.getTable(data).then(function(res) {
        // console.log(res.data)
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          const { list, totalNumber } = res.data;

          list.map(lis => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });

          that.newData = false;
          that.tableData = list;
          that.total = totalNumber;
          that.loading = false;
        }
      });

      //
      that.handleModelData(); // 获取系列
      // 门店
      that.getStoreList();
      // 经销商
      that.getPartnerList();
    }
  },
  mounted() {
    var that = this;
    that.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/page/Mjgl.vue